$('a[href*="#"]').click(function(event) {

    var href = $(this.hash);

    if (href.length) {
        event.preventDefault();
        $('html, body').animate({
            scrollTop: href.offset().top - 85
        }, 750, function() {
            if (history.pushState) {
                history.pushState(null, null, '#' + href.attr('id'));
            } else {
                location.hash = href.attr('id');
            }
        });
    }
});

$( document ).ready(function() {
    $('.sf__sub-menu-link2').filter(function () {
        return $(this).text() == '...';
    }).addClass( "invisible_header_menu" );
});